import {
  input_styles_default
} from "./chunk.CBDKO4MC.js";
import {
  FormControl
} from "./chunk.HH2JJZ37.js";
import {
  IMask
} from "./chunk.7I2462UJ.js";
import {
  l as l2
} from "./chunk.SQVLNLTX.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/input/input.ts
import { t as t2 } from "i18next";
var FadvInput = class extends FormControl {
  constructor() {
    super(...arguments);
    this.isPasswordVisible = false;
    this.type = "text";
    this.clearable = false;
    this.togglePassword = false;
    this.required = false;
    this.value = "";
  }
  get valueAsDate() {
    var _a, _b;
    return (_b = (_a = this.input) == null ? void 0 : _a.valueAsDate) != null ? _b : null;
  }
  set valueAsDate(newValue) {
    if (!newValue) {
      this.value = "";
      return;
    }
    try {
      const input = document.createElement("input");
      input.type = "date";
      input.valueAsDate = newValue;
      this.value = input.value;
    } catch (e2) {
      const local = new Date(newValue);
      local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
      this.value = local.toJSON().slice(0, 10);
    }
  }
  get valueAsNumber() {
    var _a, _b;
    return (_b = (_a = this.input) == null ? void 0 : _a.valueAsNumber) != null ? _b : parseFloat(this.value);
  }
  set valueAsNumber(newValue) {
    const input = document.createElement("input");
    input.type = "number";
    input.valueAsNumber = newValue;
    this.value = input.value;
  }
  get formattedValue() {
    if (!this.mask)
      return this.value;
    if (!this.value)
      return this.value;
    if (this.maskInstance)
      return this.maskInstance.value;
    const mask = this.createMask(document.createElement("input"), this.mask, this.value);
    return mask.value;
  }
  set formattedValue(value) {
    if (!this.mask) {
      this.value = value;
    } else if (this.maskInstance) {
      this.maskInstance.value = value;
    } else {
      const mask = this.createMask(document.createElement("input"), this.mask, value);
      this.value = mask.unmaskedValue;
    }
  }
  firstUpdated() {
    if (this.mask) {
      const mask = this.createMask(document.createElement("input"), this.mask, this.value);
      this.value = mask.unmaskedValue;
      mask.destroy();
    }
  }
  focus(options) {
    this.input.focus(options);
  }
  blur() {
    this.input.blur();
  }
  select() {
    return this.input.select();
  }
  setSelectionRange(selectionStart, selectionEnd, selectionDirection = "none") {
    return this.input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
  }
  setRangeText(replacement, start, end, selectMode = "preserve") {
    this.input.setRangeText(replacement, start, end, selectMode);
    if (this.value !== this.input.value) {
      this.value = this.input.value;
      emit(this, "sl-input");
      emit(this, "sl-change");
    }
  }
  handleChange() {
    if (this.maskInstance) {
      this.value = this.maskInstance.unmaskedValue;
    } else {
      this.value = this.input.value;
    }
    emit(this, "sl-change");
  }
  handleClearClick(event) {
    this.value = "";
    emit(this, "sl-clear");
    emit(this, "sl-input");
    emit(this, "sl-change");
    this.input.focus();
    event.stopPropagation();
  }
  handleDisabledChange() {
    if (this.input) {
      this.input.disabled = this.disabled;
    }
  }
  handleStepChange() {
    this.input.step = this.step.toString();
  }
  handleInput() {
    if (this.maskInstance) {
      requestAnimationFrame(() => {
        if (this.maskInstance) {
          this.value = this.maskInstance.unmaskedValue;
          emit(this, "sl-input");
        }
      });
    } else {
      this.value = this.input.value;
      emit(this, "sl-input");
    }
  }
  handlePasswordToggle() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
  renderClearable() {
    var _a;
    if (!this.clearable)
      return w;
    if (((_a = this.value) == null ? void 0 : _a.length) <= 0)
      return w;
    return $`<button aria-label=${t2("components:common.clearEntry")} part="clear-button" class="input__clear" type="button" @click=${this.handleClearClick} tabindex="-1" ><slot name="clear-icon"><fadv-icon name="circle-xmark" library="solid"></fadv-icon></slot></button>`;
  }
  renderPasswordToggle() {
    if (!this.togglePassword)
      return w;
    const renderIcon = () => {
      if (this.isPasswordVisible) {
        return $`<slot name="show-password-icon"><fadv-icon name="eye-slash" library="system"></fadv-icon></slot>`;
      }
      return $`<slot name="hide-password-icon"><fadv-icon name="eye" library="system"></fadv-icon></slot>`;
    };
    return $`<button aria-label=${t2(`components:input.${this.isPasswordVisible ? "hidePassword" : "showPassword"}`)} part="password-toggle-button" class="input__password-toggle" type="button" @click=${this.handlePasswordToggle} tabindex="-1" >${renderIcon()}</button>`;
  }
  createMask(input, mask, value) {
    const definitions = this.secureMask ? {
      "9": /\d/,
      z: /[a-zA-Z]/,
      ".": /./
    } : void 0;
    const maskInstance = IMask(input, { mask, definitions });
    if (value) {
      maskInstance.value = value;
      maskInstance.updateValue();
    }
    return maskInstance;
  }
  getValue() {
    var _a, _b;
    if (!this.mask)
      return (_a = this.value) != null ? _a : "";
    const formattedValue = this.formattedValue;
    if (!formattedValue)
      return (_b = this.value) != null ? _b : "";
    if (this.secureMask && document.activeElement !== this) {
      const mask = this.mask.replace(/[[\]{}`\\]/g, "");
      if (!this.mask)
        return this.value;
      return formattedValue.split("").map((c, i2) => {
        const maskChar = mask[i2];
        if (!maskChar)
          return c;
        if (!["0", "*", "a"].includes(maskChar))
          return c;
        return "\u2022";
      }).join("");
    }
    return formattedValue;
  }
  async handleFocus() {
    var _a;
    super.handleFocus();
    if (this.mask) {
      (_a = this.maskInstance) == null ? void 0 : _a.destroy();
      await this.updateComplete;
      this.maskInstance = this.createMask(this.input, this.mask);
    }
  }
  handleBlur() {
    var _a;
    super.handleBlur();
    if (this.maskInstance) {
      (_a = this.maskInstance) == null ? void 0 : _a.destroy();
    }
  }
  renderControl() {
    return $`<span part="prefix" class="form-control__control--prefix"><slot name="prefix"></slot></span><div class="form-control__control-host">${this.renderFloatingLabel()}<input size="1" part="input" id=${this.inputId} class="form-control__control" type=${this.type === "password" && this.isPasswordVisible ? "text" : this.type} name=${l(this.name)} ?disabled=${this.disabled} ?readonly=${this.readonly} ?required=${this.required} minlength=${l(this.minlength)} maxlength=${l(this.maxlength)} min=${l(this.min)} max=${l(this.max)} step=${l(this.step)} .value=${l2(this.getValue())} autocapitalize=${l(this.autocapitalize)} autocomplete=${l(this.autocomplete)} autocorrect=${l(this.autocorrect)} ?autofocus=${this.autofocus} placeholder=${this.placeholder} spellcheck=${l(this.spellcheck)} pattern=${l(this.pattern)} inputmode=${l(this.inputmode)} aria-labelledby=${l(this.getLabelledBy())} aria-invalid=${this.invalid ? "true" : "false"} @change=${this.handleChange} @input=${this.handleInput} @focus=${this.handleFocus} @blur=${this.handleBlur} /></div>${this.renderClearable()}${this.renderPasswordToggle()}<span part="suffix" class="form-control__control--suffix"><slot name="suffix"></slot></span>`;
  }
};
FadvInput.styles = [...FormControl.styles, input_styles_default];
__decorateClass([
  t()
], FadvInput.prototype, "isPasswordVisible", 2);
__decorateClass([
  i(".form-control__control")
], FadvInput.prototype, "input", 2);
__decorateClass([
  e({ reflect: true })
], FadvInput.prototype, "type", 2);
__decorateClass([
  e({ type: Boolean })
], FadvInput.prototype, "clearable", 2);
__decorateClass([
  e({ attribute: "toggle-password", type: Boolean })
], FadvInput.prototype, "togglePassword", 2);
__decorateClass([
  e({ type: Number })
], FadvInput.prototype, "minlength", 2);
__decorateClass([
  e({ type: Number })
], FadvInput.prototype, "maxlength", 2);
__decorateClass([
  e()
], FadvInput.prototype, "min", 2);
__decorateClass([
  e()
], FadvInput.prototype, "max", 2);
__decorateClass([
  e({ type: Number })
], FadvInput.prototype, "step", 2);
__decorateClass([
  e()
], FadvInput.prototype, "pattern", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvInput.prototype, "required", 2);
__decorateClass([
  e()
], FadvInput.prototype, "autocapitalize", 2);
__decorateClass([
  e()
], FadvInput.prototype, "autocorrect", 2);
__decorateClass([
  e()
], FadvInput.prototype, "autocomplete", 2);
__decorateClass([
  e({ type: Boolean })
], FadvInput.prototype, "autofocus", 2);
__decorateClass([
  e({ type: Boolean })
], FadvInput.prototype, "spellcheck", 2);
__decorateClass([
  e()
], FadvInput.prototype, "inputmode", 2);
__decorateClass([
  e()
], FadvInput.prototype, "value", 2);
__decorateClass([
  e()
], FadvInput.prototype, "mask", 2);
__decorateClass([
  e({ attribute: "secure-mask", type: Boolean })
], FadvInput.prototype, "secureMask", 2);
__decorateClass([
  e({ attribute: "formatted-value" })
], FadvInput.prototype, "formattedValue", 1);
__decorateClass([
  watch("disabled")
], FadvInput.prototype, "handleDisabledChange", 1);
__decorateClass([
  watch("step", { waitUntilFirstUpdate: true })
], FadvInput.prototype, "handleStepChange", 1);
FadvInput = __decorateClass([
  n("fadv-input")
], FadvInput);

export {
  FadvInput
};
